<template>
    <div>
        <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-card bg-variant="light">

                <b-card bg-variant="light">
                    <div class="mb-2 d-flex align-items-center justify-content-center">
                        <strong>{{ produto.descricaoResumida }}</strong>
                    </div>
                </b-card>

                <b-form-row @keyup.enter="load">

                    <b-col cols="10">
                        <LgFinderPageUnidadeAdministrativa id="finderDepartamentoProdutoCota"
                            v-model="form.departamento" @onselect="departamentoSelect"
                            :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col cols="1">


                        <b-form-checkbox class="mt-3" v-model="form.verCota" @change="load">
                            Ver cota
                        </b-form-checkbox>

                    </b-col>
                    <b-col cols="1">

                        <b-button id="limpar-pcd" class="my-2" size="sm" style="height: 40px" pill variant="primary"
                            @click="limpar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar-pcd" title="Limpar"></b-tooltip>
                        </b-button>

                    </b-col>
                </b-form-row>
            </b-card>
            <b-table responsive small :busy="this.busy" :items="this.records" :fields="this.tableFields" :hover="true"
                show-empty>

                <template #head(select)>
                    <b-form-checkbox @change="selecionarTodos" v-model="todosSelecionados"
                        :id="'checkboxSelecionarTodos'" size="lg" :value="true" :unchecked-value="false" />

                </template>

                <template v-slot:cell(select)="row">
                    <b-form-checkbox @change="selecionarIndividual(row.item)"
                        :id="'checkboxSelecionar' + row.item.departamento" v-model="row.item.selecionado" size="lg"
                        :value="true" :unchecked-value="false" />
                </template>

                <template #empty>
                    <p>Nenhum registro encontrado</p>
                </template>

                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
            </b-table>

            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                        {{
                            totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>


            <b-form-row @submit.prevent="load">

                <b-col cols="3"></b-col>
                <b-col cols="6" class="text-center">
                    <b-button id="salvar" class=" my-2" size="sm" pill variant="success"
                        v-if="itensSelecionados && itensSelecionados.length > 0" @click="abrirform">
                        <b-icon icon="pencil-square" />
                        <b-tooltip target="salvar" title="Editar"></b-tooltip>

                    </b-button>

                    <b-button v-if="itensSelecionados && itensSelecionados.length > 0" id="cancelar" class=" my-2 ml-2"
                        size="sm" pill variant="danger" @click="limparSelecao">
                        <b-icon icon="eraser" />
                        <b-tooltip target="cancelar" title="Limpar"></b-tooltip>

                    </b-button>
                </b-col>
                <b-col cols="3"></b-col>

            </b-form-row>


        </b-modal>
        <ProdutoCotaDepartamentoForm :produto="produto" v-if="showForm" @close="fecharForm" :prefix="prefix + title"
            :itensSelecionados="itensSelecionados" />
    </div>
</template>
<script>
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import { ListResourceMixin } from "@/core/mixins/resource"
import LgFinderPageUnidadeAdministrativa from '@/components/Finders/LgFinderPageUnidadeAdministrativa.vue'
import ProdutoCotaDepartamentoForm from "./ProdutoCotaDepartamentoForm.vue";
export default {
    components: {
        ProdutoCotaDepartamentoForm,
        LgFinderPageUnidadeAdministrativa,

    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        produto: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            showForm: false,
            itensSelecionados: [],
            records: [],
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],

            form: {
                departamento: {},
                verCota: false,
            },
            showModal: true,
            title: "Configuração Cota Unidade Administrativa",


        };
    },
    computed: {
        todosSelecionados: {
            get() {
                return this.records && this.records.length > 0 && this.records.every(i => i.selecionado);
            },
            set(valor) {
                this.records.forEach(i => i.selecionado = valor);
            }
        },

        tableFields() {
            return [
                {
                    key: "select",
                    label: "",
                },
                {
                    key: "sigla",
                    label: "Sigla",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                    thClass: "text-left",
                },
                {
                    key: "descricaoDepartamento",
                    label: "Departamento",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "quantidade",
                    label: "Cota",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
            ]
        },
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/configuracao-cota-departamento`);

        this.load();
    },
    watch: {
        page() {
            this.load()
        },
    },
    methods: {
        fecharForm() {
            this.showForm = false;
            this.resetarAndLoad();
        },
        abrirform() {
            this.showForm = true;
        },
        limparSelecao() {
            this.itensSelecionados = []
            this.records.forEach(record => {
                record.selecionado = false;
            });

        },
        selecionarIndividual(item) {
            if (item.selecionado)
                this.itensSelecionados.push(item);
            else
                this.itensSelecionados.splice(this.records.find(
                    recordSelecionado => item.departamento == recordSelecionado.departamento
                ), 1);

        },
        selecionarTodos(valor) {
            this.itensSelecionados = [];

            this.records.forEach(record => {
                record.selecionado = valor;

                if (valor)
                    this.itensSelecionados.push(record);
                else
                    this.itensSelecionados.splice(this.records.find(
                        recordSelecionado => record.departamento == recordSelecionado.departamento
                    ), 1);

            });

        },

        limpar() {
            this.form.departamento = {};
            this.form.verCota = false;
            this.load();
        },
        departamentoSelect(item) {
            this.form.departamento = item;
            this.load();
        },
        async resetarAndLoad(){

            this.itensSelecionados = [];
            this.load();
        },
        async load() {


            this.filtro = {};

            this.filtro.verCota = this.form.verCota;

            if (this.form.departamento)
                this.filtro.departamento = this.form.departamento.id;

            if (this.produto.id)
                this.filtro.produto = this.produto.id

            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });

            this.itensSelecionados.forEach(recordSelecionado => {
                if (this.records)
                    this.records.forEach(record => {
                        if (recordSelecionado.departamento == record.departamento)
                            record.selecionado = true;
                    });
            }
            );


        },

        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
